import { setAccessToken } from '../session.slice';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createAccessToken } from '@/utils';

export const updateSessionAction = createAsyncThunk(
	'auth/sessionUpdate',
	(payload: any, { dispatch }: any = {}) => {
		const { accessToken } = payload;

		const access = createAccessToken(accessToken);

		if (!access) {
			return;
		}

		dispatch(setAccessToken(access));
	}
);
